<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      :id="`input-billing_address_address_1`"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "@/mixins/profileInputMixin";

export default {
  name: "BillingAddress1",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('billing_address.address_1')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      name: 'billing_address.address_1',
      defaultLabel: this.$t("Address 1")
    }
  }
}
</script>

<style scoped>

</style>
